import React, { useContext } from 'react'

import FieldSearch from 'common/fields/linking/components/FieldSearch'
import { usePickerStyle } from 'common/fields/linking/hooks/usePickerStyle'
import MCEditorContext from 'components/MCTextEditor/MCEditorContext'
import { exportVariable } from 'components/MCTextEditor/variables/adapter'

import { IToolPopover } from '../toolbarInterfaces'

const Variables: IToolPopover = ({ onSelect = () => undefined }) => {
  const { variables: context } = useContext(MCEditorContext)
  const { config, getFields } = context
  const fields = getFields()
  const { hidePickerCategories, pickerWidth } = usePickerStyle(fields)
  const pickerStyle = { width: pickerWidth }

  const handleSelect = (id: string) => {
    if (id) {
      onSelect(exportVariable({ id, to_json: config.json }))
    }
  }

  return (
    <div data-onboarding-id="variables-popup" style={pickerStyle}>
      <FieldSearch fields={fields} onSelect={handleSelect} hideCategories={hidePickerCategories} />
    </div>
  )
}

export default Variables
